export default __webpack_public_path__ + "media/images/slider/slider-6-9c5b30e08fb9a0a74a67febfdbbee145.png";